import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'

// Modules
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'
import selection from './app/selection'
import dispatcher from './app/dispatcher'
import admin from './app/admin'
import history from './app/history'
import connections from './app/connections'
import communityAdmin from './app/community-admin'

const dontStoreMutations = []

const vuexLocalStorage = new VuexPersist({
  key: 'onclock-vuex',
  storage: window.localStorage, // or window.sessionStorage or localForage
  // Function that passes the state and returns the state with only the objects you want to store.
  // reducer: state => state,
  // Function that prevent storing in the localstorage
  filter: mutation => dontStoreMutations.indexOf(mutation.type) === -1, // Boolean
})

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
    selection,
    dispatcher,
    admin,
    history,
    connections,
    communityAdmin,
  },
  plugins: [vuexLocalStorage.plugin],
  strict: process.env.DEV,
})
